// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   CSS VARIABLES — overridden per theme
   ============================================================ */
.sidebar {
    --sb-bg:        linear-gradient(180deg, #1a1a2e 0%, #16213e 100%);
    --sb-border:    rgba(255,255,255,0.08);
    --sb-text:      rgba(255,255,255,0.65);
    --sb-text-head: white;
    --sb-hover-bg:  rgba(255,255,255,0.08);
    --sb-active-bg: rgba(102,126,234,0.2);
    --sb-active-cl: #667eea;
    --sb-active-bd: #667eea;
    --sb-ctrl-cl:   rgba(255,255,255,0.35);
    --sb-ctrl-h:    rgba(255,255,255,0.8);
    --sb-foot-bg:   transparent;
    --sb-gear-cl:   rgba(255,255,255,0.4);
    --sb-logout-bg: rgba(255,255,255,0.08);
    --sb-logout-cl: white;
    --sb-width:     230px;
}

/* Theme: dark-slim — same palette but narrower + smaller font */
.sidebar.sidebar-theme-dark-slim {
    --sb-width: 200px;
}
.sidebar.sidebar-theme-dark-slim .sidebar-label { font-size: 0.8rem; }
.sidebar.sidebar-theme-dark-slim .sidebar-link  { padding: 7px 16px; }

/* Theme: simple — fundo escuro, ícones minimalistas, fonte mais leve */
.sidebar.sidebar-theme-simple {
    --sb-bg:        linear-gradient(180deg, #0f172a 0%, #1e293b 100%);
    --sb-border:    rgba(255,255,255,0.07);
    --sb-text:      rgba(255,255,255,0.5);
    --sb-text-head: rgba(255,255,255,0.9);
    --sb-hover-bg:  rgba(255,255,255,0.06);
    --sb-active-bg: rgba(255,255,255,0.1);
    --sb-active-cl: #fff;
    --sb-active-bd: rgba(255,255,255,0.6);
    --sb-ctrl-cl:   rgba(255,255,255,0.3);
    --sb-ctrl-h:    rgba(255,255,255,0.8);
    --sb-gear-cl:   rgba(255,255,255,0.3);
    --sb-logout-bg: rgba(255,255,255,0.06);
    --sb-logout-cl: rgba(255,255,255,0.6);
}
.sidebar.sidebar-theme-simple .sidebar-icon {
    font-size: 1rem;
    font-style: normal;
    color: rgba(255,255,255,0.45);
    font-family: monospace;
}
.sidebar.sidebar-theme-simple .sidebar-link.active .sidebar-icon {
    color: #fff;
}
.sidebar.sidebar-theme-simple .sidebar-label {
    font-size: 0.82rem;
    font-weight: 300;
    letter-spacing: 0.02em;
}
.sidebar.sidebar-theme-simple .sidebar-link {
    border-left-width: 2px;
}
.sidebar.sidebar-theme-simple .sidebar-link.active {
    border-left-color: rgba(255,255,255,0.5);
}

/* Theme: light */
.sidebar.sidebar-theme-light {
    --sb-bg:        linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
    --sb-border:    #e2e8f0;
    --sb-text:      #4a5568;
    --sb-text-head: #1a202c;
    --sb-hover-bg:  #edf2f7;
    --sb-active-bg: #dbeafe;
    --sb-active-cl: #3182ce;
    --sb-active-bd: #3182ce;
    --sb-ctrl-cl:   #94a3b8;
    --sb-ctrl-h:    #1e293b;
    --sb-gear-cl:   #94a3b8;
    --sb-logout-bg: #edf2f7;
    --sb-logout-cl: #4a5568;
}
.sidebar.sidebar-theme-light .sidebar-header { border-bottom-color: #e2e8f0; }
.sidebar.sidebar-theme-light .sidebar-footer  { border-top-color: #e2e8f0; }
.sidebar.sidebar-theme-light .sidebar-reorder-hint { background: rgba(0,0,0,0.04); color: #94a3b8; }
.sidebar.sidebar-theme-light .sidebar-drag-handle  { color: #94a3b8; }
.sidebar.sidebar-theme-light .sidebar-reorder-arrows button { color: #94a3b8; }
.sidebar.sidebar-theme-light .sidebar-reorder-arrows button:hover:not(:disabled) { color: #1e293b; }
.sidebar.sidebar-theme-light .sidebar-controls { border-bottom-color: #e2e8f0; }
.sidebar.sidebar-theme-light .logout-btn:hover { background: #fee2e2; color: #dc2626; border-color: #fca5a5; }

/* ============================================================
   BASE SIDEBAR
   ============================================================ */
.sidebar {
    width: var(--sb-width, 230px);
    height: 100vh;
    background: var(--sb-bg);
    color: var(--sb-text);
    display: flex;
    flex-direction: column;
    position: fixed;
    left: 0;
    top: 0;
    box-shadow: 4px 0 15px rgba(0,0,0,0.15);
    z-index: 1001;
    transition: width 0.22s cubic-bezier(.4,0,.2,1);
    overflow: hidden;
}

.sidebar-collapsed {
    width: 62px !important;
}

/* ============================================================
   HEADER
   ============================================================ */
.sidebar-header {
    padding: 14px 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 58px;
    flex-shrink: 0;
}

.sidebar-logo-full { width: 130px; object-fit: contain; }
.sidebar-logo-icon { width: 34px;  object-fit: contain; }

/* ============================================================
   CONTROLS BAR (collapse / pin / reorder)
   ============================================================ */
.sidebar-controls {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2px;
    padding: 4px 8px;
    border-bottom: 1px solid var(--sb-border);
    flex-shrink: 0;
}

/* quando colapsado, centraliza o pin */
.sidebar-collapsed .sidebar-controls {
    justify-content: center;
    padding: 4px 0;
}

.sidebar-ctrl-btn {
    background: none;
    border: none;
    color: var(--sb-ctrl-cl);
    font-size: 1rem;
    cursor: pointer;
    padding: 4px 6px;
    border-radius: 4px;
    line-height: 1;
    transition: color 0.15s, background 0.15s;
    flex-shrink: 0;
}
.sidebar-ctrl-btn:hover    { color: var(--sb-ctrl-h); background: var(--sb-hover-bg); }
.sidebar-ctrl-btn.active   { color: var(--sb-ctrl-h); }
.sidebar-ctrl-btn.pinned   { color: var(--sb-active-cl); }

.sidebar-reorder-hint {
    font-size: 0.68rem;
    color: rgba(255,255,255,0.35);
    text-align: center;
    padding: 3px 8px;
    background: rgba(255,255,255,0.04);
    flex-shrink: 0;
}

/* ============================================================
   NAV
   ============================================================ */
.sidebar-nav {
    flex: 1 1;
    padding: 8px 0;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
    scrollbar-color: rgba(255,255,255,0.12) transparent;
}
.sidebar-nav::-webkit-scrollbar       { width: 4px; }
.sidebar-nav::-webkit-scrollbar-track { background: transparent; }
.sidebar-nav::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.12); border-radius: 10px; }

.sidebar-link {
    display: flex;
    align-items: center;
    padding: 9px 20px;
    color: var(--sb-text);
    text-decoration: none;
    transition: background 0.15s, color 0.15s;
    border-left: 3px solid transparent;
    white-space: nowrap;
    cursor: pointer;
}
.sidebar-link:hover {
    background: var(--sb-hover-bg);
    color: var(--sb-text-head);
}
.sidebar-link.active {
    background: var(--sb-active-bg);
    color: var(--sb-active-cl);
    border-left-color: var(--sb-active-bd);
}

/* Collapsed: centre icons */
.sidebar-collapsed .sidebar-link {
    padding: 10px 0;
    justify-content: center;
    border-left-width: 0;
    border-bottom: none;
}
.sidebar-collapsed .sidebar-link.active {
    border-left: none;
    border-right: 3px solid var(--sb-active-bd);
}

.sidebar-icon {
    font-size: 1.05rem;
    width: 22px;
    text-align: center;
    flex-shrink: 0;
    margin-right: 10px;
}
.sidebar-collapsed .sidebar-icon { margin-right: 0; }

.sidebar-label {
    font-size: 0.875rem;
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* ============================================================
   REORDER MODE
   ============================================================ */
.reorder-item         { cursor: grab; user-select: none; }
.reorder-item.dragging{ opacity: 0.45; background: var(--sb-active-bg); }

.sidebar-drag-handle {
    font-size: 0.95rem;
    color: rgba(255,255,255,0.25);
    margin-right: 8px;
    cursor: grab;
}

.sidebar-reorder-arrows {
    margin-left: auto;
    display: flex;
    flex-direction: column;
    gap: 1px;
}
.sidebar-reorder-arrows button {
    background: none;
    border: none;
    color: rgba(255,255,255,0.35);
    font-size: 0.58rem;
    cursor: pointer;
    padding: 0 2px;
    line-height: 1.2;
}
.sidebar-reorder-arrows button:hover:not(:disabled) { color: white; }
.sidebar-reorder-arrows button:disabled { opacity: 0.12; cursor: default; }

/* ============================================================
   FOOTER
   ============================================================ */
.sidebar-footer {
    padding: 12px 12px 10px;
    border-top: 1px solid var(--sb-border);
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex-shrink: 0;
}

.sidebar-footer-user {
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: 36px;
    overflow: hidden;
}

.user-avatar {
    font-size: 1.4rem;
    flex-shrink: 0;
}

.user-details {
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.user-name {
    font-size: 0.8rem;
    font-weight: 600;
    color: var(--sb-text-head);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.user-role {
    font-size: 0.68rem;
    color: var(--sb-ctrl-cl);
    text-transform: capitalize;
}

.sidebar-footer-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

/* ============================================================
   LOGOUT BUTTON
   ============================================================ */
.logout-btn {
    flex: 1 1;
    padding: 7px 10px;
    background: var(--sb-logout-bg);
    border: 1px solid var(--sb-border);
    color: var(--sb-logout-cl);
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.8rem;
    transition: background 0.2s, color 0.2s, border-color 0.2s;
    white-space: nowrap;
}
.logout-btn:hover {
    background: rgba(239,68,68,0.75);
    color: white;
    border-color: rgba(239,68,68,0.6);
}

.logout-btn-icon {
    width: 100%;
    padding: 6px;
    font-size: 1rem;
    text-align: center;
    flex: none;
}

/* ============================================================
   GEAR / SETTINGS
   ============================================================ */
.sidebar-settings-wrap {
    position: relative;
}

.sidebar-gear-btn {
    background: none;
    border: none;
    color: var(--sb-gear-cl);
    font-size: 1.1rem;
    cursor: pointer;
    padding: 4px 6px;
    border-radius: 4px;
    line-height: 1;
    transition: color 0.15s, background 0.15s;
}
.sidebar-gear-btn:hover,
.sidebar-gear-btn.active { color: var(--sb-ctrl-h); background: var(--sb-hover-bg); }

/* ============================================================
   SETTINGS MODAL — centrado no ecrã
   ============================================================ */
.settings-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.45);
    z-index: 3000;
    display: flex;
    align-items: center;
    justify-content: center;
}

.settings-modal {
    background: #1e2d40;
    border: 1px solid rgba(255,255,255,0.12);
    border-radius: 14px;
    width: 420px;
    max-width: calc(100vw - 40px);
    box-shadow: 0 24px 64px rgba(0,0,0,0.5);
    overflow: hidden;
}

.settings-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px 12px;
    border-bottom: 1px solid rgba(255,255,255,0.08);
    font-size: 0.95rem;
    font-weight: 600;
    color: rgba(255,255,255,0.9);
}

.settings-modal-close {
    background: none;
    border: none;
    color: rgba(255,255,255,0.4);
    font-size: 1rem;
    cursor: pointer;
    padding: 2px 6px;
    border-radius: 4px;
    line-height: 1;
    transition: color 0.15s, background 0.15s;
}
.settings-modal-close:hover { color: white; background: rgba(255,255,255,0.08); }

.settings-modal-body {
    padding: 16px 20px 20px;
    max-height: 70vh;
    overflow-y: auto;
}

.settings-modal-section-title {
    font-size: 0.68rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    color: rgba(255,255,255,0.35);
    margin-bottom: 8px;
}

.settings-modal-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 6px;
    margin-bottom: 4px;
}

.settings-modal-opt {
    display: flex;
    align-items: center;
    gap: 8px;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 8px;
    padding: 8px 10px;
    cursor: pointer;
    text-align: left;
    transition: background 0.15s, border-color 0.15s;
    color: rgba(255,255,255,0.75);
}
.settings-modal-opt:hover  { background: rgba(255,255,255,0.08); border-color: rgba(255,255,255,0.15); }
.settings-modal-opt.active { background: rgba(102,126,234,0.18); border-color: #667eea; }

.settings-modal-divider {
    height: 1px;
    background: rgba(255,255,255,0.08);
    margin: 14px 0;
}

.settings-modal-admin-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
}

.settings-modal-admin-label {
    font-size: 0.72rem;
    color: rgba(255,255,255,0.35);
    min-width: 50px;
}

.theme-dot {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    flex-shrink: 0;
    border: 2px solid rgba(255,255,255,0.15);
}
.theme-dot-dark      { background: linear-gradient(135deg, #1a1a2e, #16213e); }
.theme-dot-dark-slim { background: linear-gradient(135deg, #1e2533, #0f1923); }
.theme-dot-light     { background: linear-gradient(135deg, #f8fafc, #e2e8f0); border-color: #cbd5e0; }
.theme-dot-simple    { background: none; border-color: rgba(255,255,255,0.25); }

/* Page theme dots */
.page-theme-dot-default { background: linear-gradient(135deg, #f0f2f5, #e2e8f0); border-color: #cbd5e0; }
.page-theme-dot-light   { background: #ffffff; border-color: #cbd5e0; }
.page-theme-dot-dark    { background: linear-gradient(135deg, #0f172a, #1e293b); }
.page-theme-dot-simple  { background: none; border-color: rgba(255,255,255,0.25); }

/* Divider between sections in settings panel */
.sidebar-settings-divider {
    height: 1px;
    background: rgba(255,255,255,0.08);
    margin: 8px 0;
}
.sidebar-theme-light .sidebar-settings-divider {
    background: #e2e8f0;
}

.theme-opt-label { font-size: 0.8rem; font-weight: 600; line-height: 1.2; }
.theme-opt-desc  { font-size: 0.68rem; opacity: 0.55; }

.theme-check {
    margin-left: auto;
    color: #667eea;
    font-weight: 700;
    font-size: 0.85rem;
}
.sidebar-theme-light .theme-check { color: #3182ce; }

/* Admin section inside settings */
.sidebar-settings-admin {
    border-top: 1px solid rgba(255,255,255,0.08);
    margin-top: 8px;
    padding-top: 8px;
}
.sidebar-theme-light .sidebar-settings-admin { border-top-color: #e2e8f0; }

.sidebar-settings-section {
    font-size: 0.65rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: rgba(255,255,255,0.35);
    padding: 2px 6px 6px;
}
.sidebar-theme-light .sidebar-settings-section { color: #94a3b8; }

.sidebar-settings-admin-btns {
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.sidebar-admin-default-btn {
    background: none;
    border: 1px solid rgba(255,255,255,0.1);
    color: rgba(255,255,255,0.55);
    border-radius: 5px;
    padding: 4px 8px;
    font-size: 0.72rem;
    cursor: pointer;
    text-align: left;
    transition: background 0.15s;
}
.sidebar-admin-default-btn:hover { background: rgba(255,255,255,0.08); color: white; }
.sidebar-theme-light .sidebar-admin-default-btn { border-color: #e2e8f0; color: #4a5568; }
.sidebar-theme-light .sidebar-admin-default-btn:hover { background: #f1f5f9; color: #1a202c; }

/* ---- Indicador de registos tardios -----------------------------------------
   Numero de meses com despesas de cartao carregadas depois do fecho.
   position:relative no .sidebar-link e necessario para ancorar o ponto do
   estado colapsado; nada mais la dentro e posicionado, por isso e seguro. */
.sidebar-link { position: relative; }

.sidebar-badge {
    margin-left: auto;
    flex-shrink: 0;
    min-width: 18px;
    padding: 1px 6px;
    border-radius: 20px;
    background: #fee2e2;
    color: #991b1b;
    font-size: 11px;
    font-weight: 800;
    line-height: 16px;
    text-align: center;
}

/* Colapsada (62px) o link passa a justify-content:center — um pill numerico
   partiria a centragem do icone, por isso mostra-se so um ponto.
   A .sidebar tem overflow:hidden: posicionar para dentro, nunca com right
   negativo, senao fica cortado. */
.sidebar-badge-dot {
    position: absolute;
    top: 7px;
    right: 13px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #dc2626;
    animation: sb-pulse 2s ease-in-out infinite;
}

/* nome proprio: @keyframes e global e pulse-dot ja existe no Dashboard */
@keyframes sb-pulse {
    0%, 100% { opacity: 1; }
    50%      { opacity: 0.45; }
}

/* O 💳 assenta mais abaixo do que os outros emojis — os glifos de emoji trazem
   metricas proprias e este fica com a base debaixo da linha do texto, a parecer
   descaido em relacao a palavra "Cartoes". Sobe-se dois pixeis so neste, em vez
   de mexer no alinhamento de todos: os restantes estao bem como estao. */
.sidebar-link[href\$="/despesas"] .sidebar-icon {
    position: relative;
    top: -2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar.css"],"names":[],"mappings":"AAAA;;iEAEiE;AACjE;IACI,iEAAiE;IACjE,sCAAsC;IACtC,sCAAsC;IACtC,qBAAqB;IACrB,sCAAsC;IACtC,qCAAqC;IACrC,uBAAuB;IACvB,uBAAuB;IACvB,sCAAsC;IACtC,qCAAqC;IACrC,2BAA2B;IAC3B,qCAAqC;IACrC,sCAAsC;IACtC,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA,gEAAgE;AAChE;IACI,iBAAiB;AACrB;AACA,kDAAkD,iBAAiB,EAAE;AACrE,kDAAkD,iBAAiB,EAAE;;AAErE,uEAAuE;AACvE;IACI,iEAAiE;IACjE,sCAAsC;IACtC,qCAAqC;IACrC,qCAAqC;IACrC,sCAAsC;IACtC,qCAAqC;IACrC,oBAAoB;IACpB,qCAAqC;IACrC,qCAAqC;IACrC,qCAAqC;IACrC,qCAAqC;IACrC,sCAAsC;IACtC,qCAAqC;AACzC;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,6BAA6B;IAC7B,sBAAsB;AAC1B;AACA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,wCAAwC;AAC5C;;AAEA,iBAAiB;AACjB;IACI,iEAAiE;IACjE,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;AAC3B;AACA,+CAA+C,4BAA4B,EAAE;AAC7E,gDAAgD,yBAAyB,EAAE;AAC3E,qDAAqD,4BAA4B,EAAE,cAAc,EAAE;AACnG,qDAAqD,cAAc,EAAE;AACrE,8DAA8D,cAAc,EAAE;AAC9E,mFAAmF,cAAc,EAAE;AACnG,iDAAiD,4BAA4B,EAAE;AAC/E,iDAAiD,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE;;AAE7G;;iEAEiE;AACjE;IACI,6BAA6B;IAC7B,aAAa;IACb,wBAAwB;IACxB,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,OAAO;IACP,MAAM;IACN,uCAAuC;IACvC,aAAa;IACb,+CAA+C;IAC/C,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;iEAEiE;AACjE;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,qBAAqB,YAAY,EAAE,mBAAmB,EAAE;AACxD,qBAAqB,WAAW,GAAG,mBAAmB,EAAE;;AAExD;;iEAEiE;AACjE;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,yCAAyC;IACzC,cAAc;AAClB;;AAEA,uCAAuC;AACvC;IACI,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,yCAAyC;IACzC,cAAc;AAClB;AACA,6BAA6B,uBAAuB,EAAE,8BAA8B,EAAE;AACtF,6BAA6B,uBAAuB,EAAE;AACtD,6BAA6B,0BAA0B,EAAE;;AAEzD;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAClC,cAAc;AAClB;;AAEA;;iEAEiE;AACjE;IACI,SAAO;IACP,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,mDAAmD;AACvD;AACA,wCAAwC,UAAU,EAAE;AACpD,wCAAwC,uBAAuB,EAAE;AACjE,wCAAwC,kCAAkC,EAAE,mBAAmB,EAAE;;AAEjG;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;IACrB,yCAAyC;IACzC,kCAAkC;IAClC,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,8BAA8B;IAC9B,0BAA0B;AAC9B;AACA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,sCAAsC;AAC1C;;AAEA,4BAA4B;AAC5B;IACI,eAAe;IACf,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;AACA,mCAAmC,eAAe,EAAE;;AAEpD;IACI,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;iEAEiE;AACjE,wBAAwB,YAAY,EAAE,iBAAiB,EAAE;AACzD,wBAAwB,aAAa,EAAE,+BAA+B,EAAE;;AAExE;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;AACA,sDAAsD,YAAY,EAAE;AACpE,0CAA0C,aAAa,EAAE,eAAe,EAAE;;AAE1E;;iEAEiE;AACjE;IACI,uBAAuB;IACvB,sCAAsC;IACtC,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;;iEAEiE;AACjE;IACI,SAAO;IACP,iBAAiB;IACjB,+BAA+B;IAC/B,kCAAkC;IAClC,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,0DAA0D;IAC1D,mBAAmB;AACvB;AACA;IACI,gCAAgC;IAChC,YAAY;IACZ,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA;;iEAEiE;AACjE;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;IACxB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,yCAAyC;AAC7C;AACA;2BAC2B,uBAAuB,EAAE,8BAA8B,EAAE;;AAEpF;;iEAEiE;AACjE;IACI,eAAe;IACf,QAAQ;IACR,4BAA4B;IAC5B,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,wCAAwC;IACxC,mBAAmB;IACnB,YAAY;IACZ,6BAA6B;IAC7B,uCAAuC;IACvC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,+CAA+C;IAC/C,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,yCAAyC;AAC7C;AACA,8BAA8B,YAAY,EAAE,kCAAkC,EAAE;;AAEhF;IACI,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kCAAkC;IAClC,wCAAwC;IACxC,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,gDAAgD;IAChD,6BAA6B;AACjC;AACA,6BAA6B,kCAAkC,EAAE,oCAAoC,EAAE;AACvG,6BAA6B,kCAAkC,EAAE,qBAAqB,EAAE;;AAExF;IACI,WAAW;IACX,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,wCAAwC;AAC5C;AACA,uBAAuB,qDAAqD,EAAE;AAC9E,uBAAuB,qDAAqD,EAAE;AAC9E,uBAAuB,qDAAqD,EAAE,qBAAqB,EAAE;AACrG,uBAAuB,gBAAgB,EAAE,oCAAoC,EAAE;;AAE/E,oBAAoB;AACpB,0BAA0B,qDAAqD,EAAE,qBAAqB,EAAE;AACxG,0BAA0B,mBAAmB,EAAE,qBAAqB,EAAE;AACtE,0BAA0B,qDAAqD,EAAE;AACjF,0BAA0B,gBAAgB,EAAE,oCAAoC,EAAE;;AAElF,+CAA+C;AAC/C;IACI,WAAW;IACX,kCAAkC;IAClC,aAAa;AACjB;AACA;IACI,mBAAmB;AACvB;;AAEA,mBAAmB,iBAAiB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAC1E,mBAAmB,kBAAkB,EAAE,aAAa,EAAE;;AAEtD;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;AACA,oCAAoC,cAAc,EAAE;;AAEpD,kCAAkC;AAClC;IACI,4CAA4C;IAC5C,eAAe;IACf,gBAAgB;AACpB;AACA,+CAA+C,yBAAyB,EAAE;;AAE1E;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,6BAA6B;IAC7B,oBAAoB;AACxB;AACA,iDAAiD,cAAc,EAAE;;AAEjE;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,uCAAuC;IACvC,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,4BAA4B;AAChC;AACA,mCAAmC,kCAAkC,EAAE,YAAY,EAAE;AACrF,kDAAkD,qBAAqB,EAAE,cAAc,EAAE;AACzF,wDAAwD,mBAAmB,EAAE,cAAc,EAAE;;AAE7F;;;4EAG4E;AAC5E,gBAAgB,kBAAkB,EAAE;;AAEpC;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;;kCAGkC;AAClC;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA,yEAAyE;AACzE;IACI,WAAW,UAAU,EAAE;IACvB,WAAW,aAAa,EAAE;AAC9B;;AAEA;;;yEAGyE;AACzE;IACI,kBAAkB;IAClB,SAAS;AACb","sourcesContent":["/* ============================================================\r\n   CSS VARIABLES — overridden per theme\r\n   ============================================================ */\r\n.sidebar {\r\n    --sb-bg:        linear-gradient(180deg, #1a1a2e 0%, #16213e 100%);\r\n    --sb-border:    rgba(255,255,255,0.08);\r\n    --sb-text:      rgba(255,255,255,0.65);\r\n    --sb-text-head: white;\r\n    --sb-hover-bg:  rgba(255,255,255,0.08);\r\n    --sb-active-bg: rgba(102,126,234,0.2);\r\n    --sb-active-cl: #667eea;\r\n    --sb-active-bd: #667eea;\r\n    --sb-ctrl-cl:   rgba(255,255,255,0.35);\r\n    --sb-ctrl-h:    rgba(255,255,255,0.8);\r\n    --sb-foot-bg:   transparent;\r\n    --sb-gear-cl:   rgba(255,255,255,0.4);\r\n    --sb-logout-bg: rgba(255,255,255,0.08);\r\n    --sb-logout-cl: white;\r\n    --sb-width:     230px;\r\n}\r\n\r\n/* Theme: dark-slim — same palette but narrower + smaller font */\r\n.sidebar.sidebar-theme-dark-slim {\r\n    --sb-width: 200px;\r\n}\r\n.sidebar.sidebar-theme-dark-slim .sidebar-label { font-size: 0.8rem; }\r\n.sidebar.sidebar-theme-dark-slim .sidebar-link  { padding: 7px 16px; }\r\n\r\n/* Theme: simple — fundo escuro, ícones minimalistas, fonte mais leve */\r\n.sidebar.sidebar-theme-simple {\r\n    --sb-bg:        linear-gradient(180deg, #0f172a 0%, #1e293b 100%);\r\n    --sb-border:    rgba(255,255,255,0.07);\r\n    --sb-text:      rgba(255,255,255,0.5);\r\n    --sb-text-head: rgba(255,255,255,0.9);\r\n    --sb-hover-bg:  rgba(255,255,255,0.06);\r\n    --sb-active-bg: rgba(255,255,255,0.1);\r\n    --sb-active-cl: #fff;\r\n    --sb-active-bd: rgba(255,255,255,0.6);\r\n    --sb-ctrl-cl:   rgba(255,255,255,0.3);\r\n    --sb-ctrl-h:    rgba(255,255,255,0.8);\r\n    --sb-gear-cl:   rgba(255,255,255,0.3);\r\n    --sb-logout-bg: rgba(255,255,255,0.06);\r\n    --sb-logout-cl: rgba(255,255,255,0.6);\r\n}\r\n.sidebar.sidebar-theme-simple .sidebar-icon {\r\n    font-size: 1rem;\r\n    font-style: normal;\r\n    color: rgba(255,255,255,0.45);\r\n    font-family: monospace;\r\n}\r\n.sidebar.sidebar-theme-simple .sidebar-link.active .sidebar-icon {\r\n    color: #fff;\r\n}\r\n.sidebar.sidebar-theme-simple .sidebar-label {\r\n    font-size: 0.82rem;\r\n    font-weight: 300;\r\n    letter-spacing: 0.02em;\r\n}\r\n.sidebar.sidebar-theme-simple .sidebar-link {\r\n    border-left-width: 2px;\r\n}\r\n.sidebar.sidebar-theme-simple .sidebar-link.active {\r\n    border-left-color: rgba(255,255,255,0.5);\r\n}\r\n\r\n/* Theme: light */\r\n.sidebar.sidebar-theme-light {\r\n    --sb-bg:        linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);\r\n    --sb-border:    #e2e8f0;\r\n    --sb-text:      #4a5568;\r\n    --sb-text-head: #1a202c;\r\n    --sb-hover-bg:  #edf2f7;\r\n    --sb-active-bg: #dbeafe;\r\n    --sb-active-cl: #3182ce;\r\n    --sb-active-bd: #3182ce;\r\n    --sb-ctrl-cl:   #94a3b8;\r\n    --sb-ctrl-h:    #1e293b;\r\n    --sb-gear-cl:   #94a3b8;\r\n    --sb-logout-bg: #edf2f7;\r\n    --sb-logout-cl: #4a5568;\r\n}\r\n.sidebar.sidebar-theme-light .sidebar-header { border-bottom-color: #e2e8f0; }\r\n.sidebar.sidebar-theme-light .sidebar-footer  { border-top-color: #e2e8f0; }\r\n.sidebar.sidebar-theme-light .sidebar-reorder-hint { background: rgba(0,0,0,0.04); color: #94a3b8; }\r\n.sidebar.sidebar-theme-light .sidebar-drag-handle  { color: #94a3b8; }\r\n.sidebar.sidebar-theme-light .sidebar-reorder-arrows button { color: #94a3b8; }\r\n.sidebar.sidebar-theme-light .sidebar-reorder-arrows button:hover:not(:disabled) { color: #1e293b; }\r\n.sidebar.sidebar-theme-light .sidebar-controls { border-bottom-color: #e2e8f0; }\r\n.sidebar.sidebar-theme-light .logout-btn:hover { background: #fee2e2; color: #dc2626; border-color: #fca5a5; }\r\n\r\n/* ============================================================\r\n   BASE SIDEBAR\r\n   ============================================================ */\r\n.sidebar {\r\n    width: var(--sb-width, 230px);\r\n    height: 100vh;\r\n    background: var(--sb-bg);\r\n    color: var(--sb-text);\r\n    display: flex;\r\n    flex-direction: column;\r\n    position: fixed;\r\n    left: 0;\r\n    top: 0;\r\n    box-shadow: 4px 0 15px rgba(0,0,0,0.15);\r\n    z-index: 1001;\r\n    transition: width 0.22s cubic-bezier(.4,0,.2,1);\r\n    overflow: hidden;\r\n}\r\n\r\n.sidebar-collapsed {\r\n    width: 62px !important;\r\n}\r\n\r\n/* ============================================================\r\n   HEADER\r\n   ============================================================ */\r\n.sidebar-header {\r\n    padding: 14px 12px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    min-height: 58px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.sidebar-logo-full { width: 130px; object-fit: contain; }\r\n.sidebar-logo-icon { width: 34px;  object-fit: contain; }\r\n\r\n/* ============================================================\r\n   CONTROLS BAR (collapse / pin / reorder)\r\n   ============================================================ */\r\n.sidebar-controls {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 2px;\r\n    padding: 4px 8px;\r\n    border-bottom: 1px solid var(--sb-border);\r\n    flex-shrink: 0;\r\n}\r\n\r\n/* quando colapsado, centraliza o pin */\r\n.sidebar-collapsed .sidebar-controls {\r\n    justify-content: center;\r\n    padding: 4px 0;\r\n}\r\n\r\n.sidebar-ctrl-btn {\r\n    background: none;\r\n    border: none;\r\n    color: var(--sb-ctrl-cl);\r\n    font-size: 1rem;\r\n    cursor: pointer;\r\n    padding: 4px 6px;\r\n    border-radius: 4px;\r\n    line-height: 1;\r\n    transition: color 0.15s, background 0.15s;\r\n    flex-shrink: 0;\r\n}\r\n.sidebar-ctrl-btn:hover    { color: var(--sb-ctrl-h); background: var(--sb-hover-bg); }\r\n.sidebar-ctrl-btn.active   { color: var(--sb-ctrl-h); }\r\n.sidebar-ctrl-btn.pinned   { color: var(--sb-active-cl); }\r\n\r\n.sidebar-reorder-hint {\r\n    font-size: 0.68rem;\r\n    color: rgba(255,255,255,0.35);\r\n    text-align: center;\r\n    padding: 3px 8px;\r\n    background: rgba(255,255,255,0.04);\r\n    flex-shrink: 0;\r\n}\r\n\r\n/* ============================================================\r\n   NAV\r\n   ============================================================ */\r\n.sidebar-nav {\r\n    flex: 1;\r\n    padding: 8px 0;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n    scrollbar-width: thin;\r\n    scrollbar-color: rgba(255,255,255,0.12) transparent;\r\n}\r\n.sidebar-nav::-webkit-scrollbar       { width: 4px; }\r\n.sidebar-nav::-webkit-scrollbar-track { background: transparent; }\r\n.sidebar-nav::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.12); border-radius: 10px; }\r\n\r\n.sidebar-link {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 9px 20px;\r\n    color: var(--sb-text);\r\n    text-decoration: none;\r\n    transition: background 0.15s, color 0.15s;\r\n    border-left: 3px solid transparent;\r\n    white-space: nowrap;\r\n    cursor: pointer;\r\n}\r\n.sidebar-link:hover {\r\n    background: var(--sb-hover-bg);\r\n    color: var(--sb-text-head);\r\n}\r\n.sidebar-link.active {\r\n    background: var(--sb-active-bg);\r\n    color: var(--sb-active-cl);\r\n    border-left-color: var(--sb-active-bd);\r\n}\r\n\r\n/* Collapsed: centre icons */\r\n.sidebar-collapsed .sidebar-link {\r\n    padding: 10px 0;\r\n    justify-content: center;\r\n    border-left-width: 0;\r\n    border-bottom: none;\r\n}\r\n.sidebar-collapsed .sidebar-link.active {\r\n    border-left: none;\r\n    border-right: 3px solid var(--sb-active-bd);\r\n}\r\n\r\n.sidebar-icon {\r\n    font-size: 1.05rem;\r\n    width: 22px;\r\n    text-align: center;\r\n    flex-shrink: 0;\r\n    margin-right: 10px;\r\n}\r\n.sidebar-collapsed .sidebar-icon { margin-right: 0; }\r\n\r\n.sidebar-label {\r\n    font-size: 0.875rem;\r\n    font-weight: 400;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n/* ============================================================\r\n   REORDER MODE\r\n   ============================================================ */\r\n.reorder-item         { cursor: grab; user-select: none; }\r\n.reorder-item.dragging{ opacity: 0.45; background: var(--sb-active-bg); }\r\n\r\n.sidebar-drag-handle {\r\n    font-size: 0.95rem;\r\n    color: rgba(255,255,255,0.25);\r\n    margin-right: 8px;\r\n    cursor: grab;\r\n}\r\n\r\n.sidebar-reorder-arrows {\r\n    margin-left: auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 1px;\r\n}\r\n.sidebar-reorder-arrows button {\r\n    background: none;\r\n    border: none;\r\n    color: rgba(255,255,255,0.35);\r\n    font-size: 0.58rem;\r\n    cursor: pointer;\r\n    padding: 0 2px;\r\n    line-height: 1.2;\r\n}\r\n.sidebar-reorder-arrows button:hover:not(:disabled) { color: white; }\r\n.sidebar-reorder-arrows button:disabled { opacity: 0.12; cursor: default; }\r\n\r\n/* ============================================================\r\n   FOOTER\r\n   ============================================================ */\r\n.sidebar-footer {\r\n    padding: 12px 12px 10px;\r\n    border-top: 1px solid var(--sb-border);\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.sidebar-footer-user {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    min-height: 36px;\r\n    overflow: hidden;\r\n}\r\n\r\n.user-avatar {\r\n    font-size: 1.4rem;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.user-details {\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: hidden;\r\n}\r\n\r\n.user-name {\r\n    font-size: 0.8rem;\r\n    font-weight: 600;\r\n    color: var(--sb-text-head);\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.user-role {\r\n    font-size: 0.68rem;\r\n    color: var(--sb-ctrl-cl);\r\n    text-transform: capitalize;\r\n}\r\n\r\n.sidebar-footer-actions {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n/* ============================================================\r\n   LOGOUT BUTTON\r\n   ============================================================ */\r\n.logout-btn {\r\n    flex: 1;\r\n    padding: 7px 10px;\r\n    background: var(--sb-logout-bg);\r\n    border: 1px solid var(--sb-border);\r\n    color: var(--sb-logout-cl);\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    font-size: 0.8rem;\r\n    transition: background 0.2s, color 0.2s, border-color 0.2s;\r\n    white-space: nowrap;\r\n}\r\n.logout-btn:hover {\r\n    background: rgba(239,68,68,0.75);\r\n    color: white;\r\n    border-color: rgba(239,68,68,0.6);\r\n}\r\n\r\n.logout-btn-icon {\r\n    width: 100%;\r\n    padding: 6px;\r\n    font-size: 1rem;\r\n    text-align: center;\r\n    flex: none;\r\n}\r\n\r\n/* ============================================================\r\n   GEAR / SETTINGS\r\n   ============================================================ */\r\n.sidebar-settings-wrap {\r\n    position: relative;\r\n}\r\n\r\n.sidebar-gear-btn {\r\n    background: none;\r\n    border: none;\r\n    color: var(--sb-gear-cl);\r\n    font-size: 1.1rem;\r\n    cursor: pointer;\r\n    padding: 4px 6px;\r\n    border-radius: 4px;\r\n    line-height: 1;\r\n    transition: color 0.15s, background 0.15s;\r\n}\r\n.sidebar-gear-btn:hover,\r\n.sidebar-gear-btn.active { color: var(--sb-ctrl-h); background: var(--sb-hover-bg); }\r\n\r\n/* ============================================================\r\n   SETTINGS MODAL — centrado no ecrã\r\n   ============================================================ */\r\n.settings-modal-overlay {\r\n    position: fixed;\r\n    inset: 0;\r\n    background: rgba(0,0,0,0.45);\r\n    z-index: 3000;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.settings-modal {\r\n    background: #1e2d40;\r\n    border: 1px solid rgba(255,255,255,0.12);\r\n    border-radius: 14px;\r\n    width: 420px;\r\n    max-width: calc(100vw - 40px);\r\n    box-shadow: 0 24px 64px rgba(0,0,0,0.5);\r\n    overflow: hidden;\r\n}\r\n\r\n.settings-modal-header {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 16px 20px 12px;\r\n    border-bottom: 1px solid rgba(255,255,255,0.08);\r\n    font-size: 0.95rem;\r\n    font-weight: 600;\r\n    color: rgba(255,255,255,0.9);\r\n}\r\n\r\n.settings-modal-close {\r\n    background: none;\r\n    border: none;\r\n    color: rgba(255,255,255,0.4);\r\n    font-size: 1rem;\r\n    cursor: pointer;\r\n    padding: 2px 6px;\r\n    border-radius: 4px;\r\n    line-height: 1;\r\n    transition: color 0.15s, background 0.15s;\r\n}\r\n.settings-modal-close:hover { color: white; background: rgba(255,255,255,0.08); }\r\n\r\n.settings-modal-body {\r\n    padding: 16px 20px 20px;\r\n    max-height: 70vh;\r\n    overflow-y: auto;\r\n}\r\n\r\n.settings-modal-section-title {\r\n    font-size: 0.68rem;\r\n    font-weight: 700;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.6px;\r\n    color: rgba(255,255,255,0.35);\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.settings-modal-grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 6px;\r\n    margin-bottom: 4px;\r\n}\r\n\r\n.settings-modal-opt {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    background: rgba(255,255,255,0.04);\r\n    border: 1px solid rgba(255,255,255,0.08);\r\n    border-radius: 8px;\r\n    padding: 8px 10px;\r\n    cursor: pointer;\r\n    text-align: left;\r\n    transition: background 0.15s, border-color 0.15s;\r\n    color: rgba(255,255,255,0.75);\r\n}\r\n.settings-modal-opt:hover  { background: rgba(255,255,255,0.08); border-color: rgba(255,255,255,0.15); }\r\n.settings-modal-opt.active { background: rgba(102,126,234,0.18); border-color: #667eea; }\r\n\r\n.settings-modal-divider {\r\n    height: 1px;\r\n    background: rgba(255,255,255,0.08);\r\n    margin: 14px 0;\r\n}\r\n\r\n.settings-modal-admin-row {\r\n    display: flex;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n    gap: 6px;\r\n}\r\n\r\n.settings-modal-admin-label {\r\n    font-size: 0.72rem;\r\n    color: rgba(255,255,255,0.35);\r\n    min-width: 50px;\r\n}\r\n\r\n.theme-dot {\r\n    width: 14px;\r\n    height: 14px;\r\n    border-radius: 50%;\r\n    flex-shrink: 0;\r\n    border: 2px solid rgba(255,255,255,0.15);\r\n}\r\n.theme-dot-dark      { background: linear-gradient(135deg, #1a1a2e, #16213e); }\r\n.theme-dot-dark-slim { background: linear-gradient(135deg, #1e2533, #0f1923); }\r\n.theme-dot-light     { background: linear-gradient(135deg, #f8fafc, #e2e8f0); border-color: #cbd5e0; }\r\n.theme-dot-simple    { background: none; border-color: rgba(255,255,255,0.25); }\r\n\r\n/* Page theme dots */\r\n.page-theme-dot-default { background: linear-gradient(135deg, #f0f2f5, #e2e8f0); border-color: #cbd5e0; }\r\n.page-theme-dot-light   { background: #ffffff; border-color: #cbd5e0; }\r\n.page-theme-dot-dark    { background: linear-gradient(135deg, #0f172a, #1e293b); }\r\n.page-theme-dot-simple  { background: none; border-color: rgba(255,255,255,0.25); }\r\n\r\n/* Divider between sections in settings panel */\r\n.sidebar-settings-divider {\r\n    height: 1px;\r\n    background: rgba(255,255,255,0.08);\r\n    margin: 8px 0;\r\n}\r\n.sidebar-theme-light .sidebar-settings-divider {\r\n    background: #e2e8f0;\r\n}\r\n\r\n.theme-opt-label { font-size: 0.8rem; font-weight: 600; line-height: 1.2; }\r\n.theme-opt-desc  { font-size: 0.68rem; opacity: 0.55; }\r\n\r\n.theme-check {\r\n    margin-left: auto;\r\n    color: #667eea;\r\n    font-weight: 700;\r\n    font-size: 0.85rem;\r\n}\r\n.sidebar-theme-light .theme-check { color: #3182ce; }\r\n\r\n/* Admin section inside settings */\r\n.sidebar-settings-admin {\r\n    border-top: 1px solid rgba(255,255,255,0.08);\r\n    margin-top: 8px;\r\n    padding-top: 8px;\r\n}\r\n.sidebar-theme-light .sidebar-settings-admin { border-top-color: #e2e8f0; }\r\n\r\n.sidebar-settings-section {\r\n    font-size: 0.65rem;\r\n    font-weight: 700;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.5px;\r\n    color: rgba(255,255,255,0.35);\r\n    padding: 2px 6px 6px;\r\n}\r\n.sidebar-theme-light .sidebar-settings-section { color: #94a3b8; }\r\n\r\n.sidebar-settings-admin-btns {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 3px;\r\n}\r\n\r\n.sidebar-admin-default-btn {\r\n    background: none;\r\n    border: 1px solid rgba(255,255,255,0.1);\r\n    color: rgba(255,255,255,0.55);\r\n    border-radius: 5px;\r\n    padding: 4px 8px;\r\n    font-size: 0.72rem;\r\n    cursor: pointer;\r\n    text-align: left;\r\n    transition: background 0.15s;\r\n}\r\n.sidebar-admin-default-btn:hover { background: rgba(255,255,255,0.08); color: white; }\r\n.sidebar-theme-light .sidebar-admin-default-btn { border-color: #e2e8f0; color: #4a5568; }\r\n.sidebar-theme-light .sidebar-admin-default-btn:hover { background: #f1f5f9; color: #1a202c; }\r\n\n/* ---- Indicador de registos tardios -----------------------------------------\n   Numero de meses com despesas de cartao carregadas depois do fecho.\n   position:relative no .sidebar-link e necessario para ancorar o ponto do\n   estado colapsado; nada mais la dentro e posicionado, por isso e seguro. */\n.sidebar-link { position: relative; }\n\n.sidebar-badge {\n    margin-left: auto;\n    flex-shrink: 0;\n    min-width: 18px;\n    padding: 1px 6px;\n    border-radius: 20px;\n    background: #fee2e2;\n    color: #991b1b;\n    font-size: 11px;\n    font-weight: 800;\n    line-height: 16px;\n    text-align: center;\n}\n\n/* Colapsada (62px) o link passa a justify-content:center — um pill numerico\n   partiria a centragem do icone, por isso mostra-se so um ponto.\n   A .sidebar tem overflow:hidden: posicionar para dentro, nunca com right\n   negativo, senao fica cortado. */\n.sidebar-badge-dot {\n    position: absolute;\n    top: 7px;\n    right: 13px;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: #dc2626;\n    animation: sb-pulse 2s ease-in-out infinite;\n}\n\n/* nome proprio: @keyframes e global e pulse-dot ja existe no Dashboard */\n@keyframes sb-pulse {\n    0%, 100% { opacity: 1; }\n    50%      { opacity: 0.45; }\n}\r\n\n/* O 💳 assenta mais abaixo do que os outros emojis — os glifos de emoji trazem\n   metricas proprias e este fica com a base debaixo da linha do texto, a parecer\n   descaido em relacao a palavra \"Cartoes\". Sobe-se dois pixeis so neste, em vez\n   de mexer no alinhamento de todos: os restantes estao bem como estao. */\n.sidebar-link[href$=\"/despesas\"] .sidebar-icon {\n    position: relative;\n    top: -2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
